<template>
    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-printer-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Aperçu avant impression</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">
                    <!-- Controls Section -->
                    <div class="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-900">
                        <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-4">

                            <!-- Print Orientation -->
                            <div>
                                <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                                    Impression en
                                </label>
                                <select
                                        v-model="printSize"
                                        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                                >
                                    <option value="A4">Portrait</option>
                                    <option value="A4landscape">Paysage</option>
                                </select>
                            </div>

                            <!-- Date Start -->
                            <div>
                                <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                                    Date début
                                </label>
                                <input
                                        type="date"
                                        v-model="datedebut"
                                        @change="refresh"
                                        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                                >
                            </div>

                            <!-- Date End -->
                            <div v-if="viewperiode">
                                <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                                    Date fin
                                </label>
                                <input
                                        type="date"
                                        v-model="datefin"
                                        @change="refresh"
                                        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                                >
                            </div>

                            <!-- Action Buttons -->
                            <div class="flex items-end gap-2">
                                <button
                                        @click="print"
                                        class="flex-1 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
                                >
                  <span class="flex items-center justify-center gap-2">
                    <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                    </svg>
                    Imprimer
                  </span>
                                </button>
                                <button
                                        @click="exportToExcel"
                                        class="flex-1 rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                >
                  <span class="flex items-center justify-center gap-2">
                    <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Excel
                  </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Print Content -->
                    <div class="max-h-[60vh] overflow-auto rounded-lg border border-gray-200 dark:border-gray-700">
                        <div ref="printDoc" class="bg-white p-6 dark:bg-gray-800">

                            <!-- Header Section -->
                            <header class="mb-6 flex items-start justify-between border-b border-gray-200 pb-4 dark:border-gray-700">
                                <div v-if="$store.state.etatlogo" class="flex-shrink-0">
                                    <img :src="$store.state.etatlogo" alt="Logo" class="h-16 w-auto object-contain">
                                </div>
                                <div class="flex-shrink-0">
                                    <qrcode-vue value="pointdelacaisse" :size="80" level="M" />
                                </div>
                            </header>

                            <!-- Company Info Section -->
                            <section class="mb-6 grid gap-4 md:grid-cols-2">
                                <!-- Company Details -->
                                <div class="rounded-lg border border-gray-200 dark:border-gray-700">
                                    <table class="w-full text-sm">
                                        <tbody>
                                        <tr class="border-b border-gray-200 dark:border-gray-700">
                                            <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">
                                                Raison Social : {{ $store.state.etatraisonsocial }}
                                            </td>
                                        </tr>
                                        <tr class="border-b border-gray-200 dark:border-gray-700">
                                            <td class="px-4 py-2 text-gray-700 dark:text-gray-300">
                                                IFU : {{ $store.state.etatifu }} / RC N° RCCM: {{ $store.state.etatrccm }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-4 py-2 text-gray-700 dark:text-gray-300">
                                                Téléphone : {{ $store.state.etattelephone }} / {{ $store.state.etatadresse }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Report Info -->
                                <div class="rounded-lg border border-gray-200 dark:border-gray-700">
                                    <table class="w-full text-sm">
                                        <tbody>
                                        <tr class="border-b border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-900">
                                            <td colspan="2" class="px-4 py-2 text-center font-semibold text-gray-900 dark:text-white">
                                                {{ subtitle }}
                                            </td>
                                        </tr>
                                        <tr class="border-b border-gray-200 dark:border-gray-700">
                                            <td class="px-4 py-2 text-center text-gray-700 dark:text-gray-300">
                                                {{ viewperiode ? 'PERIODE' : 'JOURNEE DU' }}
                                            </td>
                                            <td class="px-4 py-2 text-center text-gray-700 dark:text-gray-300">
                                                IMPRIMER PAR
                                            </td>
                                        </tr>
                                        <tr class="border-b border-gray-200 dark:border-gray-700">
                                            <td class="px-4 py-2 text-center font-medium text-gray-900 dark:text-white">
                                                {{ viewperiode ? `${datedebut} - ${datefin}` : datejournee }}
                                            </td>
                                            <td class="px-4 py-2 text-center font-medium text-gray-900 dark:text-white">
                                                {{ $store.state.appusername }}
                                            </td>
                                        </tr>
                                        <tr v-if="!viewPeriode">
                                            <td colspan="2" class="px-4 py-2 text-center text-gray-700 dark:text-gray-300">
                                                PERIODE {{ datedebut }} - {{ datefin }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>

                            <!-- Data Tables Section -->
                            <section ref="exportableTable" class="space-y-6">

                                <!-- Solde à l'ouverture -->
                                <DataTable
                                        title="Report solde caisse"
                                        :columns="['Report', 'Montant']"
                                        :data="soldeOuvertureData"
                                        :show-total="false"
                                        :empty-message="'Aucune donnée trouvée'"
                                />

                                <!-- Retours de fonds -->
                                <DataTable
                                        title="Liste des retours de fonds"
                                        :columns="['Caisse', 'N°Document', 'Date', 'Bénéficiaire', 'Motif / raison', 'Saisir par', 'Montant']"
                                        :data="retourFondsData"
                                        :total="totals.ref"
                                        total-label="Total"
                                        :total-colspan="6"
                                />

                                <!-- Approvisionnements par la banque -->
                                <DataTable
                                        title="Liste des approvisionnements par la banque"
                                        :columns="['N°Document', 'Date', 'Motif / raison', 'Banque', 'Caisse', 'Montant']"
                                        :data="approBanqueData"
                                        :total="totals.appro"
                                        total-label="Total"
                                        :total-colspan="5"
                                />

                                <!-- Facturations au comptoir -->
                                <DataTable
                                        title="Liste des Facturations au comptoir"
                                        :columns="['N° DOCUMENT', 'DATE', 'CAISSE', 'COLLABORATEUR', 'REMISE', 'MONTANT', 'MONTANT RESTANT']"
                                        :data="facturationData"
                                        :totals-row="facturationTotals"
                                        :total-colspan="4"
                                />

                                <!-- Règlements clients -->
                                <DataTable
                                        title="Liste des règlements clients"
                                        :columns="['N° DOCUMENT', 'DATE', 'CAISSE', 'MONTANT']"
                                        :data="reglementClientData"
                                        :total="totals.regClt"
                                        total-label="Total"
                                        :total-colspan="3"
                                />

                                <!-- Règlements BCDCA -->
                                <DataTable
                                        title="Liste des règlements BCDCA"
                                        :columns="['N° DOCUMENT', 'DATE', 'CAISSE', 'MONTANT']"
                                        :data="bcdcaData"
                                        :total="totals.bcdca"
                                        total-label="Total"
                                        :total-colspan="3"
                                />

                                <!-- Règlements fournisseurs -->
                                <DataTable
                                        title="Liste des règlements fournisseurs"
                                        :columns="['N° DOCUMENT', 'DATE', 'CAISSE', 'MONTANT']"
                                        :data="reglementFournisseurData"
                                        :total="totals.regFrs"
                                        total-label="Total"
                                        :total-colspan="3"
                                />

                                <!-- Dépôts clients -->
                                <DataTable
                                        title="Liste des dépôts clients"
                                        :columns="['N° DOCUMENT', 'DATE', 'CAISSE', 'CLIENT', 'MONTANT']"
                                        :data="depotClientData"
                                        :total="totals.depotClt"
                                        total-label="Total"
                                        :total-colspan="4"
                                />

                                <!-- Transferts de fonds -->
                                <DataTable
                                        title="Liste des transferts de fonds de caisse"
                                        :columns="['N°Document', 'Date', 'Motif / raison', 'Caisse créditeur', 'Caisse débiteur', 'Montant']"
                                        :data="transfertFondsData"
                                        :total="totals.approc"
                                        total-label="Total"
                                        :total-colspan="5"
                                />

                                <!-- Dépenses -->
                                <DataTable
                                        title="Liste des dépenses"
                                        :columns="['Caisse', 'N°Document', 'Date', 'Bénéficiaire', 'Motif / raison', 'Saisir par', 'Montant']"
                                        :data="depenseData"
                                        :total="totals.depense"
                                        total-label="Total"
                                        :total-colspan="6"
                                />

                                <!-- Solde Final -->
                                <div class="rounded-lg border-2 border-emerald-500 bg-emerald-50 p-4 text-center dark:bg-emerald-900/20">
                                    <p class="text-lg font-bold text-emerald-700 dark:text-emerald-400">
                                        Arrêté la présente caisse à la somme : {{ formatMoney(soldeEnCaisse) }}
                                    </p>
                                </div>
                            </section>

                            <!-- Signatures -->
                            <section class="mt-8 grid grid-cols-2 gap-8">
                                <div class="text-center">
                                    <p class="font-semibold text-gray-900 dark:text-white">Caissier</p>
                                    <div class="mt-16 border-t border-gray-300 pt-2 dark:border-gray-600">
                                        <p class="text-sm text-gray-600 dark:text-gray-400">&nbsp;</p>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <p class="font-semibold text-gray-900 dark:text-white">RESPONSABLE TRESORERIE</p>
                                    <div class="mt-16 border-t border-gray-300 pt-2 dark:border-gray-600">
                                        <p class="text-sm text-gray-600 dark:text-gray-400">
                                            {{ $store.state.paramsapp?.signataire?.caisseresponsablefinancier?.name || '' }}
                                        </p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="print" type="button" class="ti-btn ti-btn-primary-full"><i class="ri-printer-line align-middle"></i> Imprimer</button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>
</template>

<script>
    /*import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";*/
    import {
        currencyFormatDE, currencyFormatMonney,
        currentDate,
        currentDateTime,
        ExportExcel, FormatNumber, generateQR,
        getYear,
        impression, isValidDateString, NumbertoLettre,
        randomString
    } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import qrcode from 'qrcode.vue'
    const axios =require('axios');
    import DataTable from './datatableComponnent';

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },
            searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

            }

        },
        computed: {
            subtitle() {
                //this.printSize = 'A4';
                return "POINT DE LA CAISSE";
            },

            // Formatted data for tables
            soldeOuvertureData() {
                return this.dataSoldeOuverture.map(item => [
                    item.nomcaisse,
                    this.formatMoney(item.montant)
                ]);
            },

            retourFondsData() {
                return this.dataRetourFonds.map(item => [
                    item.nomcaisse,
                    item.numdoc,
                    item.dateop,
                    item.beneficiaire,
                    item.motif,
                    item.saisir_par,
                    this.formatMoney(item.montant)
                ]);
            },

            approBanqueData() {
                return this.dataAppro.map(item => [
                    item.numdoc,
                    item.datop,
                    item.motif,
                    item.banque,
                    item.caisse,
                    this.formatMoney(item.cmontant)
                ]);
            },

            facturationData() {
                return this.dataCAFacture.map(item => [
                    item.docref,
                    item.dateop,
                    item.nomcaisse,
                    item.collaborateur,
                    this.formatMoney(item.mtntremise),
                    this.formatMoney(item.montanttotal),
                    this.formatMoney(item.montanttotalrestant)
                ]);
            },

            facturationTotals() {
                const totals = this.calculateFacturationTotals();
                return [
                    'Total', '', '', '',
                    this.formatMoney(totals.remise),
                    this.formatMoney(totals.montant),
                    this.formatMoney(totals.restant)
                ];
            },

            reglementClientData() {
                return this.dataReglementClient.map(item => [
                    item.numdoc,
                    item.dateop,
                    item.nomcaisse,
                    this.formatMoney(item.montant)
                ]);
            },

            bcdcaData() {
                return this.dataBCDCA.map(item => [
                    item.numdoc,
                    item.dateop,
                    item.nomcaisse,
                    this.formatMoney(item.montant)
                ]);
            },

            reglementFournisseurData() {
                return this.dataReglementFournisseur.map(item => [
                    item.numdoc,
                    item.dateop,
                    item.nomcaisse,
                    this.formatMoney(item.montant)
                ]);
            },

            depotClientData() {
                return this.dataDepotClient.map(item => [
                    item.numdoc,
                    item.dateop,
                    item.nomcaisse,
                    item.beneficiaire,
                    this.formatMoney(item.montant)
                ]);
            },

            transfertFondsData() {
                return this.dataApproc.map(item => [
                    item.numdoc,
                    item.datop,
                    item.motif,
                    item.caissecrediteur,
                    item.caissedebiteur,
                    this.formatMoney(item.cmontant)
                ]);
            },

            depenseData() {
                return this.dataDepense.map(item => [
                    item.nomcaisse,
                    item.numdoc,
                    item.dateop,
                    item.beneficiaire,
                    item.motif,
                    item.saisir_par,
                    this.formatMoney(item.montant)
                ]);
            },

            // Totals
            totals() {
                return {
                    ref: this.calculateTotal(this.dataRetourFonds, 'montant'),
                    depense: this.calculateTotal(this.dataDepense, 'montant'),
                    approc: this.calculateTotal(this.dataApproc, 'cmontant'),
                    appro: this.calculateTotal(this.dataAppro, 'cmontant'),
                    regClt: this.calculateTotal(this.dataReglementClient, 'montant'),
                    regFrs: this.calculateTotal(this.dataReglementFournisseur, 'montant'),
                    depotClt: this.calculateTotal(this.dataDepotClient, 'montant'),
                    bcdca: this.calculateTotal(this.dataBCDCA, 'montant'),
                    soldeOuverture: this.calculateTotal(this.dataSoldeOuverture, 'montant'),
                };
            },

            soldeEnCaisse() {
                const factTotals = this.calculateFacturationTotals();
                const caEncaisse = factTotals.montant - factTotals.restant;

                return (
                    this.totals.soldeOuverture +
                    this.totals.ref +
                    this.totals.appro +
                    this.totals.approc +
                    caEncaisse +
                    this.totals.regClt +
                    this.totals.depotClt -
                    this.totals.depense -
                    this.totals.regFrs -
                    this.totals.bcdca
                );
            }
        },
        components: {
            /*templatesite,
            appheader,
            appsidebar,
            appmenu,*/
            qrcode,
            DataTable

        },

        data() {
            return {
                printSize: 'A4',
                mmois:"",
                manne:"",
                typetableau:1,
                mfontsize:10,
                taillemodel:'A4',
                mgetyear:getYear(),
                datenow:currentDate(),
                isdisplay:false,
                viewperiode:false,
                titlemodal:"",
                datatable:[],
                messageerror:"",
                messagesucces:"",
                viewdrop:false,
                tabvalue:{},

                datejournee:"",
                datedebut:"",
                numpidcaisse:"",
                datefin:"",
                searchword:"",
                searchtrierletableau:"",


                datatablenewarraySOLDEALOUVERTURE:[],
                datatablenewarrayCAISSEBCD:[],
                datatablenewarrayRGLTCLT:[],
                datatablenewarrayRGLTFRS:[],
                datatablenewarrayDEPOTCLT:[],
                datatablenewarrayREF:[],
                datatablenewarraydepense:[],
                datatablearrayAPPROC:[],
                datatablearrayAPPRO:[],
                tableCAparfactureparcollaborateur:[],

                totalmontantp:0,
                totalmontantrestant:0,
                totalREMISE:0,



                mydocmag:'',
                totalmontant:0,
                totaldebit:0,
                totalcredit:0,


                // Data arrays
                dataSoldeOuverture: [],
                dataBCDCA: [],
                dataReglementClient: [],
                dataReglementFournisseur: [],
                dataDepotClient: [],
                dataRetourFonds: [],
                dataDepense: [],
                dataApproc: [],
                dataAppro: [],
                dataCAFacture: [],









                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 1,
                Defaultpage: 1,
                DefaultperPage: 1,
                pages: [],

                textToEncode: '',  // Initial text to encode in QR code
                size: 100,              // Size of the QR code
                level: 'L'              // Error correction level ('L', 'M', 'Q', 'H')
            };
        },
        methods: {

            // Data methods
            async refresh_old() {
                if (!isValidDateString(this.dateDebut) || !isValidDateString(this.dateFin)) {
                    return;
                }

                if (!this.viewPeriode) {
                    this.dateFin = this.dateDebut;
                }

                this.$store.dispatch('lancerchargement', true);

                try {
                    const url = `${process.env.VUE_APP_API_URL}/egl74587kjkjrfdkcaisse771714dfe/c/rapport/${this.dateDebut}/${this.dateFin}/${this.numPidCaisse}/${this.$store.state.appsociete}/8954fddpap18rapportcaisse519151911515/${randomString()}`;

                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    console.log("response.data ***** ",response)

                    if (response.data.success) {
                        console.log("response.data.m ***** ",response.data.m)
                        this.setDataFromResponse(response.data.m);
                    } else {
                        this.resetData();
                    }
                } catch (error) {
                    console.error('Erreur lors du chargement des données:', error);
                    this.resetData();
                } finally {
                    this.$store.dispatch('lancerchargement', false);
                }
            },



            setDataFromResponse(data) {

                this.dataRetourFonds = data.newarrayREF || [];
                this.dataDepense = data.newarraydepense || [];
                this.dataApproc = data.arrayAPPROC || [];
                this.dataAppro = data.arrayAPPRO || [];
                this.dataCAFacture = data.CAparfactureparcollaborateur || [];
                this.dataSoldeOuverture = data.newarraySOLDEALOUVERTURE || [];
                this.dataBCDCA = data.newarrayBCDCA || [];
                this.dataReglementClient = data.newarrayRGLTCLT || [];
                this.dataReglementFournisseur = data.newarrayRGLTFRS || [];
                this.dataDepotClient = data.newarrayDEPOTCLIENT || [];
            },

            resetData() {
                this.dataRetourFonds = [];
                this.dataDepense = [];
                this.dataApproc = [];
                this.dataAppro = [];
                this.dataCAFacture = [];
                this.dataSoldeOuverture = [];
                this.dataBCDCA = [];
                this.dataReglementClient = [];
                this.dataReglementFournisseur = [];
                this.dataDepotClient = [];
            },

            // Export methods
            async print() {
                const styles = this.printSize.includes('landscape')
                    ? [
                        `${process.env.VUE_APP_URL}print/bootstrap.min.css`,
                        `${process.env.VUE_APP_URL}print/stylelandscape1.css`,
                        `${process.env.VUE_APP_URL}print/stylelandscape.css`
                    ]
                    : [
                        `${process.env.VUE_APP_URL}print/bootstrap.min.css`,
                        `${process.env.VUE_APP_URL}print/styleportrait.css`
                    ];

                const printContent = this.$refs.printDoc.innerHTML;
                impression(printContent,styles,window.document.title,[],{ format: this.taillemodel });
            },

            exportToExcel() {
                const name = `POINT DE LA CAISSE (${this.dateDebut} - ${this.dateFin})_${currentDateTime()}`;
                const element = this.$refs.exportableTable;
                ExportExcel('xlsx', name, null, null, element);
            },



            calculateTotal(array, field) {
                return array.reduce((sum, item) => sum + parseFloat(item[field] || 0), 0);
            },

            calculateFacturationTotals() {
                return this.dataCAFacture.reduce((acc, item) => ({
                    remise: acc.remise + parseFloat(item.mtntremise || 0),
                    montant: acc.montant + parseFloat(item.montanttotal || 0),
                    restant: acc.restant + parseFloat(item.montanttotalrestant || 0)
                }), { remise: 0, montant: 0, restant: 0 });
            },


            /*****************************************************************************************/



            async urlcodeqr(value){
                let qrDataURL = await generateQR(value);
                return qrDataURL;

            },


            formatMonney(value){
                return currencyFormatMonney(value)

            },


            numbertolettre(chiffre){

                return NumbertoLettre(chiffre)

            },


            btnviewdrop(){

                if(this.viewdrop===true){

                    this.viewdrop=false;

                }else{

                    this.viewdrop=true;

                }



            },

            ExportExcel(type,name, fn, dl) {
                name=name+"_"+currentDateTime()
                var elt = this.$refs.exportable_table;
                ExportExcel(type,name, fn, dl,elt);

            },

            async print4 () {


                let t=this
                let $style=[];

                let options = {  name: '_blank', }


                if (this.taillemodel==="A4landscape" || this.taillemodel==="A5landscape" ){

                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/stylelandscape1.css',
                        process.env.VUE_APP_URL+'print/stylelandscape.css'
                    ]


                }

                if (this.taillemodel==="A4" || this.taillemodel==="A5" ){


                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/styleportrait.css',
                        // process.env.VUE_APP_URL+'print/custom_print_a4.css',
                    ]

                }

                const printContent = this.$refs.printdoc.innerHTML;
                impression(printContent,$style,window.document.title,[],{ format: this.taillemodel })

            },

            formatMoney(value){
                return currencyFormatDE(value)

            },

            formatnumber(value){
                return FormatNumber(value)

            },

            returnFloatconvert(value){

                //console.log('value ',value)

                let mval= parseFloat(value)

                return mval.toFixed(4)
            },

            close(){

                this.isdisplay=false;

                this.$emit('closed');

            },

            selected(datavalue){


                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { typ: this.typedoc, value: datavalue};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('elementSelectionne', elementSelectionne);

                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },

            async show(numpidcaisse,datedouverture){


                this.titlemodal="POINT DE LA CAISSE"


                if (datedouverture!==""){

                    this.viewperiode=false;
                    this.datejournee=datedouverture
                    this.datedebut=datedouverture
                    this.datefin=datedouverture
                    this.numpidcaisse=numpidcaisse

                    this.refresh()

                }
                else{

                    this.viewperiode=true;
                    this.datedebut=currentDate()
                    this.datefin=currentDate()
                    this.numpidcaisse=numpidcaisse
                    this.refresh()

                }

                this.isdisplay=true;
            },


            async refresh(){

                ///m/egl74587kjkjrfdkcaisse771714dfe/c/rapport//2024-04-17/16890669630JtN0t0N123MJ3L3171S6SL3J012MJ/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6InlibDR0alBneE4xNzA1MDYxNDY0eWJsNHRqUGd4TjA0MDExMjAxMTEyMDI0UE0iLCJpYXQiOjE3MTgzNzU4NDAsImV4cCI6MTcxODQ2MjI0MH0.75b0f9xyDsYgeTAU3gLrcdh0M-2c_U7T-UElpU2N9Jc/8954fddpap18rapportcaisse519151911515/j9jj5Amzcghz5hF2u749f092upt4c3ks7s92okB243qlylgB2c1o555rf2ljjkE9AC68859BEtAz05wlx60bn734B277937pEsB95k8de33z7nl2q255g3n01F0Dqbldn4Axp00f7C44m4tB32xqmaEF7jl79j9j757346A7jD2k7hj29bk4

                if (!isValidDateString(this.datedebut) || !isValidDateString(this.datefin)){return }

                if (this.viewperiode===false){this.datefin=this.datedebut;}



                this.$store.dispatch('lancerchargement',true)
                const t = this;
                // '/m/caisse/c/rapportperiode/:datedebut/:datefin/:pidcaisse/:keyuser/rapportcaisse6v2/:ftoken'
                //let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/c/rapport/'+this.datedebut+'/'+this.datefin+'/'+this.numpidcaisse+'/'+this.$store.state.appsociete+'/8954fddpap18rapportcaisse519151911515/'+randomString();
                let url=process.env.VUE_APP_API_URL+'/caisse/c/rapportperiode/'+this.datedebut+'/'+this.datefin+'/'+this.numpidcaisse+'/'+this.$store.state.appsociete+'/rapportcaisse6v2/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)
                        t.datatable=[];

                        /*if(res.data.success){

                            t.datatablenewarrayREF=res.data.m.newarrayREF
                            t.datatablenewarraydepense=res.data.m.newarraydepense
                            t.datatablearrayAPPROC=res.data.m.arrayAPPROC
                            t.datatablearrayAPPRO=res.data.m.arrayAPPRO
                            t.tableCAparfactureparcollaborateur=res.data.m.CAparfactureparcollaborateur

                            t.datatablenewarraySOLDEALOUVERTURE=res.data.m.newarraySOLDEALOUVERTURE
                            t.datatablenewarrayCAISSEBCD=res.data.m.newarrayBCDCA
                            t.datatablenewarrayRGLTCLT=res.data.m.newarrayRGLTCLT
                            t.datatablenewarrayRGLTFRS=res.data.m.newarrayRGLTFRS
                            t.datatablenewarrayDEPOTCLT=res.data.m.newarrayDEPOTCLIENT

                            //t.isdisplay=true;

                        }
                        else{
                            t.datatable=[];

                            t.datatablenewarrayREF=[]
                            t.datatablenewarraydepense=[]
                            t.datatablearrayAPPROC=[]
                            t.datatablearrayAPPRO=[]
                            t.tableCAparfactureparcollaborateur=[]
                            t.datatablenewarraySOLDEALOUVERTURE=[]
                            t.datatablenewarrayCAISSEBCD=[]
                            t.datatablenewarrayRGLTCLT=[]
                            t.datatablenewarrayRGLTFRS=[]
                            t.datatablenewarrayDEPOTCLT=[]

                        }*/


                        if (res.data.success) {
                            console.log("res.data.m ***** ",res.data.m)
                            t.setDataFromResponse(res.data.m);
                        } else {
                            t.resetData();
                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })













            },


            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .table td {
        cursor: pointer;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xxl { max-width:100%; }


        .h-screen,.mybodyheight200px,.mybodyheight300px, .mybodyheight400px,.mybodyheight500px{
            height: 100%!important;
        }


    }

    /* Custom scrollbar */
    .overflow-auto::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    .overflow-auto::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    .overflow-auto::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
    }

    .overflow-auto::-webkit-scrollbar-thumb:hover {
        background: #a1a1a1;
    }

    /* Print styles */
    @media print {
        .no-print {
            display: none !important;
        }
    }

</style>